import axios from 'axios';

export const BACKEND_URL = 'https://silabor-strapi.dingegno.com';
const API_URL = BACKEND_URL + '/api';